import { render, staticRenderFns } from "./FooterSocials.vue?vue&type=template&id=c9a4ba06&"
import script from "./FooterSocials.vue?vue&type=script&lang=js&"
export * from "./FooterSocials.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocials.vue?vue&type=style&index=0&id=c9a4ba06&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports